"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractMerchantInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ContractMerchantInput = (props) => {
    const { name, data = {}, required, multiple, readOnly } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    (0, react_hooks_1.useDidMountEffect)(() => {
        if (merchantId) {
            form.setValue(name, [], { shouldDirty: true, shouldTouch: true });
        }
    }, [merchantId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { required: required, name: name, controller: "contracts", multiple: multiple, readOnly: readOnly, fetchData: { ...data, merchantId } }));
};
exports.ContractMerchantInput = ContractMerchantInput;
//# sourceMappingURL=index.js.map